// src/components/ImageSlider.js

import React from 'react';
import './ImageSlider.css';

const ImageSlider = ({ images }) => {
  return (
    <div className="slider h-auto overflow-hidden relative w-full mx-auto">
      <div className="slide-track flex animate-scroll">
        {images.concat(images).map((image, index) => (
          <div key={index} className="slide w-auto h-auto flex-shrink-0">
            <img src={image.src} alt='Partner Images' className="w-[50%] h-full scal" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
